<template>
	<div class="home">
		<Encabezado></Encabezado>

		<div id="content" class="snap-content bg-home">
			<div class="container">
				<div class="header-clear"></div>
				<div id="itemList">
					<div class="itemList-controls">
						<div class="controls controls-left">
							<router-link class="btn GeneralLeave-back btnBack" to="/permisos">
								<font-awesome-icon icon="fa-solid fa-circle-chevron-left" />
								Atrás
							</router-link>
						</div>
						<div class="title">
							<h3>Permisos Retribuidos y Ausencias</h3>
						</div>
					</div>
					<div class="itemList-header">
						<h1>Edición permiso retribuido / ausencia</h1>
					</div>
					<div class="item-Form">
						<div class="panel-body">
							<form
								class="form-horizontal"
								id="formEdicionPermiso"
								@submit.prevent="enviarDatosFormulario"
							>
								<div class="form-group">
									<div class="col-md-12 col-xs-12">
										<label for="GeneralLeave_TipoAusenciaValue"
											>Motivo de Permiso</label
										>
										<select
											v-model="idTipoAusencia"
											class="form-control valid"
											data-val="true"
											data-val-number="The field Motivo de Permiso must be a number."
											data-val-required="El campo Motivo de Permiso es obligatorio."
											id="GeneralLeave_TipoAusenciaValue"
											name="GeneralLeave.TipoAusenciaValue"
											disabled
										>
											<option
												v-for="tipoAusencia in tiposAusencia"
												:value="tipoAusencia.id"
											>
												{{ tipoAusencia.nombre }}
											</option>
										</select>
										<span
											class="text-danger field-validation-valid"
											data-valmsg-for="GeneralLeave.TipoAusenciaValue"
											data-valmsg-replace="true"
										></span>
										<span id="descripcionTipoAusencia">
											<div>
												<div>
													<span>
														{{ tipoAusenciaSeleccionado.descripcion }}
													</span>
												</div>
												<div>
													<small
														v-if="
															tipoAusenciaSeleccionado.descripcionJustificante
														"
													>
														Justificación:
														{{
															tipoAusenciaSeleccionado.descripcionJustificante
														}}
													</small>
												</div>
											</div>
										</span>
									</div>
								</div>
								<hr />
								<div class="form-group">
									<div class="col-md-6 col-xs-12">
										<label for="fechaDesde">Fecha Desde</label>
										<br />
										<date-picker
											class="dateTimePicker"
											v-model="fechaDesde"
											value-type="format"
											:editable="false"
											:formatter="momentFormat"
											:clearable="false"
										></date-picker>
										<br />
										<date-picker
											v-if="permiteHoras"
											class="dateTimePicker"
											v-model="horaDesde"
											format="HH:mm"
											value-type="format"
											type="time"
											:editable="false"
											:minute-step="5"
											:clearable="false"
											:disabled="numDias > 1"
										></date-picker>
										<br />
										<br />
									</div>
									<div class="col-md-6 col-xs-12">
										<label for="fechaHasta">Fecha Hasta</label>
										<br />
										<date-picker
											class="dateTimePicker"
											v-model="fechaHasta"
											value-type="format"
											:editable="false"
											:formatter="momentFormat"
											:clearable="false"
										></date-picker>
										<br />
										<date-picker
											v-if="permiteHoras"
											class="dateTimePicker"
											v-model="horaHasta"
											format="HH:mm"
											value-type="format"
											type="time"
											:editable="false"
											:minute-step="5"
											:clearable="false"
											:disabled="numDias > 1"
										></date-picker>
										<br />
										<br />
									</div>
								</div>
								<div class="form-group">
									<div class="col-md-6 col-xs-12">
										<label for="numDias">Número de días</label>
										<input
											class="form-control"
											id="numDias"
											name="numDias"
											readonly="readonly"
											type="text"
											:value="numDiasFormateado"
										/>
									</div>
									<div
										v-if="permiteHoras"
										class="col-md-6 col-xs-12"
										style="display: block"
									>
										<label for="numHoras">Número de horas</label>
										<input
											class="form-control"
											id="numHoras"
											name="numHoras"
											readonly="readonly"
											type="text"
											:value="numHorasFormateado"
										/>
									</div>
								</div>
								<hr />

								<div class="divAttachment">
									<div class="form-group">
										<div class="col-md-12">
											<label
												>Archivos adjuntos (máx. 3 archivos de 10Mb cada
												uno)</label
											>

											<br />
											<br />

											<input
												id="adjunto_1"
												class="hidden"
												type="file"
												ref="adjunto_1"
												@change="cambio_adjunto('adjunto_1')"
												accept=".pdf, .jpg, .jpeg"
												:capture="esAndroid ? 'environment' : null"
											/>

											<div class="button-group btn-group-justified">
												
												<span class="btn-group">
													<button
														style="border-radius: 4px 0px 0px 0px;"
														type="button"
														class="btn btn-warning"
														:class="{ disabled: adjunto_1 !== '' }"
														@click="seleccionarAdjunto('adjunto_1')"
													>
														<font-awesome-icon icon="fa-solid fa-circle-plus" />
														Adj.
													</button>
												</span>
												<span class="btn-group">
													<button
														type="button"
														class="btn btn-danger"
														:class="{ disabled: adjunto_1 === '' }"
														@click="quitarAdjunto('adjunto_1')"
													>
														<font-awesome-icon
															icon="fa-solid fa-times-circle"
														/>
														Quitar
													</button>
												</span>
												<span class="btn-group">
													<button
														style="border-radius: 0px 4px 0px 0px;"
														type="button"
														class="btn btn-success"
														:class="{ disabled: (adjunto_1 === '') || (typeof adjunto_1 == 'object') }"
														@click="descargarAdjunto('adjunto_1')"
													>
														<font-awesome-icon icon="fa-solid fa-eye" />
														Desc.
													</button>
												</span>
											</div>

											<input
												style="border-radius: 0px 0px 4px 4px;"
												placeholder="Archivo adjunto 1"
												type="text"
												id="caja_adjunto_1"
												class="form-control"
												readonly
												:value="nombreAdjunto_1"
												@click="seleccionarAdjunto('adjunto_1')"
											/>

											

											<br />
											<br />

											<input
												id="adjunto_2"
												class="hidden"
												type="file"
												ref="adjunto_2"
												@change="cambio_adjunto('adjunto_2')"
												accept=".pdf, .jpg, .jpeg"
												:capture="esAndroid ? 'environment' : null"
											/>
											
											<div class="button-group btn-group-justified">
												<span class="btn-group">
													<button
														style="border-radius: 4px 0px 0px 0px;"
														type="button"
														class="btn btn-warning"
														:class="{ disabled: adjunto_2 !== '' }"
														@click="seleccionarAdjunto('adjunto_2')"
													>
														<font-awesome-icon icon="fa-solid fa-circle-plus" />
														Adj.
													</button>
												</span>
												<span class="btn-group">
													<button
														type="button"
														class="btn btn-danger"
														:class="{ disabled: adjunto_2 === '' }"
														@click="quitarAdjunto('adjunto_2')"
													>
														<font-awesome-icon
															icon="fa-solid fa-times-circle"
														/>
														Quitar
													</button>
												</span>
												<span class="btn-group">
													<button
														style="border-radius: 0px 4px 0px 0px;"
														type="button"
														class="btn btn-success"
														:class="{ disabled: (adjunto_2 === '') || (typeof adjunto_2 == 'object') }"
														@click="descargarAdjunto('adjunto_2')"
													>
														<font-awesome-icon icon="fa-solid fa-eye" />
														Desc.
													</button>
												</span>
											</div>

											<input
												style="border-radius: 0px 0px 4px 4px;"
												placeholder="Archivo adjunto 2"
												type="text"
												id="caja_adjunto_2"
												class="form-control"
												readonly
												:value="nombreAdjunto_2"
												@click="seleccionarAdjunto('adjunto_2')"
											/>
											

											<br />
											<br />

											<input
												id="adjunto_3"
												class="hidden"
												type="file"
												ref="adjunto_3"
												@change="cambio_adjunto('adjunto_3')"
												accept=".pdf, .jpg, .jpeg"
												:capture="esAndroid ? 'environment' : null"
											/>
											
											<div class="button-group btn-group-justified">
												<span class="btn-group">
													<button
														style="border-radius: 4px 0px 0px 0px;"
														type="button"
														class="btn btn-warning"
														:class="{ disabled: adjunto_3 !== '' }"
														@click="seleccionarAdjunto('adjunto_3')"
													>
														<font-awesome-icon icon="fa-solid fa-circle-plus" />
														Adj.
													</button>
												</span>
												<span class="btn-group">
													<button
														type="button"
														class="btn btn-danger"
														:class="{ disabled: adjunto_3 === '' }"
														@click="quitarAdjunto('adjunto_3')"
													>
														<font-awesome-icon
															icon="fa-solid fa-times-circle"
														/>
														Quitar
													</button>
												</span>
												<span class="btn-group">
													<button
														style="border-radius: 0px 4px 0px 0px;"
														type="button"
														class="btn btn-success"
														:class="{ disabled: (adjunto_3 === '') || (typeof adjunto_3 == 'object') }"
														@click="descargarAdjunto('adjunto_3')"
													>
														<font-awesome-icon icon="fa-solid fa-eye" />
														Desc.
													</button>
												</span>
												
											</div>
											
											<input
												style="border-radius: 0px 0px 4px 4px;"
												placeholder="Archivo adjunto 3"
												type="text"
												id="caja_adjunto_3"
												class="form-control"
												readonly
												:value="nombreAdjunto_3"
												@click="seleccionarAdjunto('adjunto_3')"
											/>

										</div>
									</div>
								</div>

								<hr />

								<div class="form-group">
									<div class="col-md-12">
										<label for="observaciones">Observaciones</label>
										<textarea
											class="form-control"
											cols="20"
											id="observaciones"
											name="observaciones"
											v-model="observaciones"
											rows="5"
										></textarea>
									</div>
								</div>
								<div class="form-group">
									<div class="col-md-12"></div>
								</div>
								<div class="form-group">
									<div class="col-md-12">
										<div v-if="superaMaximoDias" class="text-danger">
											Aviso.- El número de días no puede superar lo establecido
											(
											<strong>
												{{ tipoAusenciaSeleccionado.maximoDias }} día/s
											</strong>
											)
										</div>
										<div v-if="!cumpleJustificante" class="text-danger">
											Aviso.- El tipo de permiso seleccionado requiere que
											adjunte un justificante (<strong>{{
												tipoAusenciaSeleccionado.descripcionJustificante.trim()
											}}</strong
											>)
										</div>
										<div
											v-if="tipoNoPermiteDiasConsecutivosYesConsecutivo"
											class="text-danger"
										>
											Aviso.- No es posible solicitar permiso por
											<strong>{{ tipoAusenciaSeleccionado.nombre }}</strong>
											para el/los mismo/s día/s (o día/s consecutivo/s) a los ya
											solicitados.
										</div>
									</div>
								</div>
								<div class="form-group">
									<div class="col-md-12">
										<input
											:disabled="!datosValidos || enviandoDatosFormulario"
											type="submit"
											class="btn btn-lg btn-primary"
											id="btnSave"
											:value="textoBtnEnvio"
										/>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<Footer></Footer>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import Encabezado from "@/components/Encabezado.vue";
import Footer from "@/components/Footer.vue";
import router from "@/router";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";

export default {
	name: "EdicionPermiso",
	components: {
		Encabezado,
		Footer,
		DatePicker,
	},
	data() {
		return {
			idPermisoSeleccionado: null,
			idTipoAusencia: null,
			fechaDesde: null,
			fechaHasta: null,
			horaDesde: null,
			horaHasta: null,
			adjunto_1: null,
			adjunto_2: null,
			adjunto_3: null,
			observaciones: null,
			momentFormat: {
				//[optional] Date to String
				stringify: (date) => {
					return date ? moment(date).format("L") : "";
				},
				//[optional]  String to Date
				parse: (value) => {
					return value ? moment(value, "L").toDate() : null;
				},
				//[optional] getWeekNumber
				getWeek: (date) => {
					return; // a number
				},
			},
			limiteMegasAdjuntos: 10,
			esAndroid: /Android/i.test(navigator.userAgent)
		};
	},
	beforeMount() {
		// console.log(this.permiso.adjunto_1);
		// console.log(this.permiso.adjunto_2);
		// console.log(this.permiso.adjunto_3);

		this.idPermisoSeleccionado = this.permiso.id;
		this.idTipoAusencia = this.permiso.id_tipoAusencia;
		this.fechaDesde = moment(this.permiso.fechaDesde).format("L");
		this.fechaHasta = moment(this.permiso.fechaHasta).format("L");
		this.horaDesde = moment(this.permiso.horaDesde, "HH:mm").format("HH:mm");
		this.horaHasta = moment(this.permiso.horaHasta, "HH:mm").format("HH:mm");
		this.adjunto_1 =
			this.permiso.adjunto_1 == "null" ? null : this.permiso.adjunto_1;
		this.adjunto_2 =
			this.permiso.adjunto_2 == "null" ? null : this.permiso.adjunto_2;
		this.adjunto_3 =
			this.permiso.adjunto_3 == "null" ? null : this.permiso.adjunto_3;
		this.observaciones = this.permiso.observaciones;
	},
	mounted() {
		this.$store.commit("establecerEstadoEnviandoDatosFormulario", false);
		this.$store.commit("establecerGuardadoOK", false);

		document.body.classList.remove("bg-login");
		document.body.classList.remove("login-page");
	},
	watch: {
		fechaDesde: function () {
			if (this.numDias < 1) {
				this.fechaHasta = this.fechaDesde;
			}
		},
		fechaHasta: function () {
			if (this.numDias < 1) {
				this.fechaHasta = this.fechaDesde;
			}
		},
		horaDesde: function () {
			if (this.numHoras < 0) {
				this.horaHasta = this.horaDesde;
			}
		},
		horaHasta: function () {
			if (this.numHoras < 0) {
				this.horaHasta = this.horaDesde;
			}
		},
		guardadoOK: function (newValue) {
			if (newValue) {
				this.$toast.open({
					message: "Los datos se han guardado correctamente",
					type: "success",
					duration: 500,
					dismissible: false,
					position: "top",
					onDismiss: this.redireccionListaPermisos,
				});
			}
		},
	},
	computed: {
		permisos: function () {
			let permisos = this.$store.state.perfil.permisos || [];

			return Array.isArray(permisos) ? permisos : [permisos];
		},
		permiso: function () {
			let permiso = null;

			if (this.permisos.length > 0) {
				permiso = this.permisos.find((permiso_) => {
					return permiso_.id == this.$route.params.id_permiso;
				});
			}

			return permiso;
		},
		guardadoOK: function () {
			return this.$store.state.guardadoOK;
		},
		permiteHoras: function () {
			return this.tipoAusenciaSeleccionado.permiteHoras * 1;
		},
		numDias: function () {
			const desde = moment(this.fechaDesde, "L");
			const hasta = moment(this.fechaHasta, "L");
			let dias = hasta.diff(desde, "days");

			if (dias) {
				this.horaDesde = "00:00";
				this.horaHasta = "00:00";
			}

			if (!this.diaNatural) {
				const festivosIncluidos = this.festivos.filter((x) =>
					moment(x).isBetween(desde, hasta, undefined, "[]")
				);

				dias -= festivosIncluidos.length;
			}

			return dias + 1;
		},
		festivos: function () {
			return this.$store.state.perfil.calendario.map((x) => x.festivo);
		},
		numDiasFormateado: function () {
			return this.numHoras ? 0 : this.numDias;
		},
		diaNatural: function () {
			return this.tipoAusenciaSeleccionado.diaNatural * 1;
		},
		leyendaDiasHabilesNaturales: function () {
			return this.diaNatural ? "naturales" : "hábiles";
		},
		numHoras: function () {
			const desde = moment(this.horaDesde, "HH:mm");
			const hasta = moment(this.horaHasta, "HH:mm");
			const horas = hasta.diff(desde, "minutes");

			return horas;
		},
		numHorasFormateado: function () {
			const horas = `0${Math.floor(this.numHoras / 60)}`.slice(-2);
			const minutos = `0${this.numHoras % 60}`.slice(-2);

			return `${horas}:${minutos}`;
		},
		tiposAusencia: function () {
			const tiposAusencia = this.$store.state.perfil.tiposAusencia || [];

			return Array.isArray(tiposAusencia) ? tiposAusencia : [tiposAusencia];
		},
		tipoAusenciaSeleccionado: function () {
			const self = this;

			return self.tiposAusencia.find((tipoAusencia) => {
				return tipoAusencia.id == self.idTipoAusencia;
			});
		},
		superaMaximoDias: function () {
			if (this.tipoAusenciaSeleccionado.maximoDias == 0) {
				return false;
			}
			if (this.tipoAusenciaSeleccionado.maximoDias > 0) {
				return this.numDias > this.tipoAusenciaSeleccionado.maximoDias;
			}

			return this.numDias > 1;
		},
		requiereJustificante: function () {
			return !!(this.tipoAusenciaSeleccionado.justificante * 1);
		},
		adjuntaJustificante: function () {
			return !!this.adjunto_1 || !!this.adjunto_2 || !!this.adjunto_3;
		},
		cumpleJustificante: function () {
			return (
				!this.requiereJustificante ||
				(this.requiereJustificante && this.adjuntaJustificante)
			);
		},
		datosValidos: function () {
			if (this.superaMaximoDias) return false;
			if (!this.cumpleJustificante) return false;
			if (this.tipoNoPermiteDiasConsecutivosYesConsecutivo) return false;

			return true;
		},
		textoBtnEnvio: function () {
			if (this.enviandoDatosFormulario) return "Enviando...";
			if (this.datosValidos) return "Enviar";
			if (!this.datosValidos) return "Revise Avisos";
		},
		tamanioMaximoAdjuntos: function () {
			return this.limiteMegasAdjuntos * 1048576;
		},
		enviandoDatosFormulario: function () {
			return this.$store.state.enviandoDatosFormulario;
		},
		nombreAdjunto_1: function () {
			if (typeof this.adjunto_1 == "string") return this.adjunto_1;
			return !!this.adjunto_1 ? this.adjunto_1.name : "";
		},
		nombreAdjunto_2: function () {
			if (typeof this.adjunto_2 == "string") return this.adjunto_2;
			return !!this.adjunto_2 ? this.adjunto_2.name : "";
		},
		nombreAdjunto_3: function () {
			if (typeof this.adjunto_3 == "string") return this.adjunto_3;
			return !!this.adjunto_3 ? this.adjunto_3.name : "";
		},
		tipoPermiteDiasConsecutivos: function () {
			const { diasConsecutivos } = this.tipoAusenciaSeleccionado;
			return !!(diasConsecutivos * 1);
		},
		tipoNoPermiteDiasConsecutivosYesConsecutivo: function () {
			if (!this.tipoPermiteDiasConsecutivos) {
				const self = this;
				const desdeSeleccionado = moment(this.fechaDesde, "L");
				const hastaSeleccionado = moment(this.fechaHasta, "L");
				let permisos = this.$store.state.perfil.permisos || [];

				permisos = Array.isArray(permisos) ? permisos : [permisos];

				return permisos
					.filter(function (permiso) {
						const mismoTipo = permiso.id_tipoAusencia === self.idTipoAusencia;
						const noRechazado = permiso.estado !== "Rechazado";
						const noEditando = permiso.id !== self.idPermisoSeleccionado;
						const noAnuladoPorTrabajador = permiso.estado !== 'Anulado por trabajador';
						return mismoTipo && noRechazado && noEditando && noAnuladoPorTrabajador;
					})
					.some(function (permiso) {
						const desdeMenosUnDia = moment(
							permiso.fechaDesde,
							"YYYY-MM-DD"
						).subtract(1, "days");
						const hastaMasUnDia = moment(permiso.fechaHasta, "YYYY-MM-DD").add(
							1,
							"days"
						);
						const checkDesde = desdeSeleccionado.isBetween(
							desdeMenosUnDia,
							hastaMasUnDia,
							undefined,
							"[]"
						);
						const checkHasta = hastaSeleccionado.isBetween(
							desdeMenosUnDia,
							hastaMasUnDia,
							undefined,
							"[]"
						);
						return checkDesde || checkHasta;
					});
			}
			return false;
		},
	},
	methods: {
		formatDate: function (date) {
			return this.moment(date).format("DD/MM/YYYY hh:mm");
		},
		enviarDatosFormulario: function () {
			this.$store.dispatch("enviarDatosEdicionPermiso", {
				idPermisoSeleccionado: this.idPermisoSeleccionado,
				fechaDesde: this.fechaDesde,
				fechaHasta: this.fechaHasta,
				horaDesde: this.horaDesde,
				horaHasta: this.horaHasta,
				adjunto_1: this.adjunto_1,
				adjunto_2: this.adjunto_2,
				adjunto_3: this.adjunto_3,
				observaciones: this.observaciones,
			});
		},
		seleccionarAdjunto: function (id) {
			this.$refs[id].click();
		},
		quitarAdjunto: function (id) {
			this.$refs[id].value = "";

			return (this[id] = "");
		},
		cambio_adjunto: function (id) {
			const adjunto = this.$refs[id].files[0];
			const nombres_adjuntos = [
				this.nombreAdjunto_1.toUpperCase(),
				this.nombreAdjunto_2.toUpperCase(),
				this.nombreAdjunto_3.toUpperCase(),
			];
			const expr_reg = /^[A-Za-z0-9-_\s]+[.]{1}[A-Za-z]{3,4}$/; //control del nombre del adjunto (sin eñes ni acentos)

			this.$refs[id].value = "";

			if (!expr_reg.test(adjunto.name)) {
				return this.mostrarMensajeErrorNombreArchivoConCaracteresEspeciales();
			}

			if (nombres_adjuntos.includes(adjunto.name.toUpperCase())) {
				if (adjunto.name.toUpperCase() === 'IMAGE.JPG'){
					const archivo = adjunto;
					const nombreUnico = `imagen_${Date.now()}.jpg`;
					const archivoRenombrado = new File([archivo], nombreUnico, {
						type: archivo.type,
						lastModified: archivo.lastModified
					});
					if (id === "adjunto_1") return this.adjunto_1 = archivoRenombrado;
					if (id === "adjunto_2") return this.adjunto_2 = archivoRenombrado;
					if (id === "adjunto_3") return this.adjunto_3 = archivoRenombrado;
				}
				return this.mostrarMensajeErrorMismoNombreAdjunto();
			}

			if (adjunto.size < this.tamanioMaximoAdjuntos) {
				return (this[id] = adjunto);
			}

			this.mostrarMensajeErrorTamanioAdjunto();
		},
		mostrarMensajeErrorMismoNombreAdjunto: function () {
			this.$toast.open({
				message: "Ya existe un archivo con el mismo nombre",
				type: "error",
				duration: 3000,
				dismissible: false,
				position: "top",
			});
		},
		mostrarMensajeErrorNombreArchivoConCaracteresEspeciales: function () {
			this.$toast.open({
				message:
					"No se pueden añadir archivos con caracteres especiales en el nombre (ni eñes ni acentos)",
				type: "error",
				duration: 3000,
				dismissible: false,
				position: "top",
			});
		},
		mostrarMensajeErrorTamanioAdjunto: function () {
			this.$toast.open({
				message: "No es posible adjuntar archivos de más de 10Mb",
				type: "error",
				duration: 3000,
				dismissible: false,
				position: "top",
			});
		},
		redireccionListaPermisos: function () {
			router.replace("/permisos");
			this.$store.commit("establecerGuardadoOK", false);
		},
		descargarAdjunto: function (adjunto) {
			this.$store.dispatch("descargarAdjunto", {
				adjunto: this[adjunto],
				categoria: "permisos",
				id: this.permiso.id,
			});
		},
	},
};
</script>

<style>
@import "../assets/styles/home.css";
.dateTimePicker {
	width: 100%;
}
</style>
